import { useEffect, useState } from 'react';
import useSelector from '../../redux/typedHooks';

let euwaPromise: Promise<EUWA> | null = null;

export const usePuzzelEUWA = () => {
  const [euwa, setEuwa] = useState<EUWA | undefined>();

  const configId = useSelector((state) => state.application.puzzelConfigurationId);
  const customerKey = useSelector((state) => state.application.puzzelCustomerKey);

  useEffect(() => {
    let isMounted = true;

    const initEUWA = async () => {
      try {
        if (!configId || !customerKey) return;
        if (!euwaPromise) {
          euwaPromise = import('@puzzel/euwa-wrapper').then(({ EUWA }) => new EUWA({ configId, customerKey }, {}));
          euwaPromise.catch(() => {
            euwaPromise = null;
          });
        }
        const instance = await euwaPromise;
        if (isMounted) {
          setEuwa(instance);
        }
      } catch (err) {
        console.error('[usePuzzelEUWA] failed to initialize', err);
      }
    };

    const timeoutId = window.setTimeout(() => {
      initEUWA();
    }, 3000);

    return () => {
      isMounted = false;
      window.clearTimeout(timeoutId);
    };
  }, [configId, customerKey]);

  return euwa;
};
